import { Button } from "@shared/components/untitledui/base/buttons/button"
import { Input } from "@shared/components/untitledui/base/input/input"
import { useState } from "react"
import { ViewShell } from "./ViewShell"

/** "What would you like to call this template?" — name the lesson before saving it as a template. */
export function TemplateNameView({
  onCancel,
  onSave,
}: {
  onCancel: () => void
  /** Called with the chosen name; the caller saves the template and closes the menu. */
  onSave: (name: string) => void
}) {
  const [name, setName] = useState("")
  const trimmedName = name.trim()
  const save = () => {
    if (trimmedName !== "") onSave(trimmedName)
  }

  return (
    <ViewShell
      actions={
        <>
          <Button color="secondary" size="md" className="flex-1" onPress={onCancel}>
            Cancel
          </Button>
          <Button
            data-test="view confirm"
            color="primary"
            size="md"
            className="flex-1"
            isDisabled={trimmedName === ""}
            onPress={save}
          >
            Save
          </Button>
        </>
      }
    >
      {/* Template Name */}
      <div className="px-5 pt-4">
        <Input
          aria-label="Template name"
          placeholder="Template Name"
          autoFocus
          value={name}
          onChange={setName}
          onKeyDown={(event) => {
            if (event.key === "Enter") save()
          }}
        />
      </div>
    </ViewShell>
  )
}
